import ListItemComponent, { IStateListItem } from 'components/Abstract/ListItem';
import Snackbar from 'components/Shared/Snackbar';
import { WithStyles } from 'decorators/withStyles';
import React from 'react';
import { combineLatest } from 'rxjs';
import RxOp from 'rxjs-operators';
import authService from 'services/auth';
import selectedVentureService from 'services/profile';

import ViewGeneral from './View/General';

// import ViewEntity from './View/Entity';
// import Toolbar from 'components/Layout/Toolbar';
// import ViewVenture from './View/Venture';

interface IProps {
  history: any;
  match?: any;
  classes?: any;
}
interface IState extends IStateListItem {
  name?: string;
}
@WithStyles(theme => ({
  dashboardViews: {
    gridGap: theme.spacing(2),
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
  },
  header: {
    display: 'flex',
    flex: 1,
    justifyContent: 'space-between'
  }
}))
export default class Dashboard extends ListItemComponent<IProps, IState> {
  componentDidMount() {
    this.loadData();
  }

  loadData = () => {
    combineLatest([
      authService.getUser(),
      selectedVentureService.getSelectedVenture()
    ]).pipe(
      RxOp.bindComponent(this),
      RxOp.logError()
    ).subscribe(([user, selection]) => {
      if (!selection || !user) {
        return this.props.history.push('/');
      }

      // const showComparison = [
      //   userRoles.sysAdmin,
      //   userRoles.admin,
      //   userRoles.holding].some(role => user.roles.includes(role));

      this.setState({ name: selection.name });
    }, error => Snackbar.error(error));
  }

  render() {

    return (
      <>
        <ViewGeneral />
      </>
    );
  }
}
